import type { FlexContainerJsxProps } from "./flex-container-jsx.type";

import FlexContainer from "../flex-container.component";

const FlexContainerJsx = ({
  value,
  fullWidth,
  noWrapper,
  ...containerProps
}: FlexContainerJsxProps) => {
  let content = undefined;
  if (value) {
    const style = fullWidth ? { width: "100%" } : undefined;
    content = noWrapper ? value : <div style={style}>{value}</div>;
  }
  return <FlexContainer {...containerProps} value={content} />;
};

export default FlexContainerJsx;
